import { Trophy, Zap, Globe, Clock, Battery, Music, Radio, Sunrise, Flame, Award, Calendar, Ear, Mic, EyeOff, Users, UserPlus, Send, Mail, BookOpen, Brain, Heart, Shield, Lightbulb, HeartHandshake, Star, Medal, CircleDot, Target, Anchor, Wind, Ghost } from 'lucide-react';

export const ACHIEVEMENTS = [
    {
        id: 'first_qso',
        name: 'First Contact',
        description: 'Complete your first simulated QSO',
        icon: Radio,
        level: 'Novice',
        color: 'text-cyan-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('first_qso')
    },
    {
        id: 'speed_demon_30',
        name: 'Speed Demon 30',
        description: 'Reach 30 WPM',
        icon: Zap,
        level: 'General',
        color: 'text-yellow-400',
        condition: (p, s, w, y, c, m, st, t, u) => w >= 30
    },
    {
        id: 'speed_demon_40',
        name: 'Speed Demon 40',
        description: 'Reach 40 WPM',
        icon: Flame,
        level: 'Extra',
        color: 'text-orange-500',
        condition: (p, s, w, y, c, m, st, t, u) => w >= 40
    },
    {
        id: 'speed_55',
        name: "I Can't Drive 55",
        description: 'Reach 55+ WPM speed',
        icon: Music,
        level: 'Extra',
        color: 'text-red-400',
        condition: (p, s, w, y, c, m, st, t, u) => w >= 55
    },
    {
        id: 'perfect_copy',
        name: 'Perfect Copy',
        description: '100% accuracy on 10 characters in a row',
        icon: Award,
        level: 'Novice',
        color: 'text-green-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('perfect_copy')
    },
    {
        id: 'dx_hunter',
        name: 'DX Hunter',
        description: 'Practice with 20 different countries',
        icon: Globe,
        level: 'General',
        color: 'text-blue-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('dx_hunter')
    },
    {
        id: 'century_club',
        name: 'Century Club',
        description: 'Complete 100 practice sessions',
        icon: Trophy,
        level: 'General',
        color: 'text-amber-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('century_club')
    },
    {
        id: 'night_owl',
        name: 'Night Owl',
        description: 'Practice between 2 AM and 4 AM',
        icon: Clock,
        level: 'Extra',
        color: 'text-indigo-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('night_owl')
    },
    {
        id: 'early_bird',
        name: 'Early Bird',
        description: 'Practice between 5 AM and 7 AM',
        icon: Sunrise,
        level: 'General',
        color: 'text-amber-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('early_bird')
    },
    {
        id: 'marathon',
        name: 'Marathon',
        description: 'Practice for 60 minutes in one session',
        icon: Clock,
        level: 'Extra',
        color: 'text-purple-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('marathon')
    },
    {
        id: 'globetrotter',
        name: 'Globetrotter',
        description: 'Copy callsigns from all continents',
        icon: Globe,
        level: 'Extra',
        color: 'text-teal-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('globetrotter')
    },
    {
        id: 'straight_key_sk',
        name: 'Straight Key SK',
        description: 'Send 500 characters in Straight Key mode',
        icon: CircleDot,
        level: 'Novice',
        color: 'text-slate-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('straight_key_sk')
    },
    {
        id: 'the_natural',
        name: 'The Natural',
        description: 'Complete a level with 100% accuracy without Farnsworth spacing',
        icon: Music,
        level: 'General',
        color: 'text-green-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('the_natural')
    },
    {
        id: 'qrp_hero',
        name: 'QRP Hero',
        description: 'Complete an exchange with max QSB (fading)',
        icon: Battery,
        level: 'Extra',
        color: 'text-yellow-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('qrp_hero')
    },
    {
        id: 'iron_arm',
        name: 'Iron Arm',
        description: 'Maintain a Straight Key session for > 15 minutes',
        icon: Trophy,
        level: 'General',
        color: 'text-gray-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('iron_arm')
    },
    {
        id: 'paddle_master',
        name: 'Paddle Master',
        description: 'Complete all 36 Koch characters using Paddle',
        icon: Zap,
        level: 'Extra',
        color: 'text-cyan-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('paddle_master') || (p.level >= 36 && u.inputMode === 'paddle')
    },
    {
        id: 'bug_virtuoso',
        name: 'Bug Virtuoso',
        description: 'Complete all 36 Koch characters using Bug',
        icon: Music,
        level: 'Extra',
        color: 'text-lime-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('bug_virtuoso') || (p.level >= 36 && u.inputMode === 'bug')
    },
    {
        id: 'straight_key_master',
        name: 'Straight Key Master',
        description: 'Complete all 36 Koch characters using Straight Key',
        icon: Award,
        level: 'Extra',
        color: 'text-stone-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('straight_key_master') || (p.level >= 36 && (u.inputMode === 'straight' || u.inputMode === 'straight_key'))
    },
    {
        id: 'gray_line',
        name: 'Gray Line',
        description: 'Practice during local sunrise or sunset',
        icon: Sunrise,
        level: 'General',
        color: 'text-orange-300',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('gray_line')
    },
    {
        id: 'sos',
        name: 'SOS',
        description: 'Key ... --- ...',
        icon: Radio,
        level: 'Novice',
        color: 'text-red-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('sos')
    },
    {
        id: 'yyz',
        name: 'Nice one, eh?',
        description: 'Key Y-Y-Z in sequence',
        icon: Music,
        level: 'Extra',
        color: 'text-red-500',
        secret: true,
        text: 'YYZ',
        condition: (p, s, w, y, c, m, st, t, u) => y === true
    },
    {
        id: 'cwo',
        name: 'Continuous Wave Order',
        description: 'this group can see the KI7QCF for the trees',
        icon: Radio,
        level: 'Extra',
        color: 'text-cyan-400',
        secret: true,
        text: 'CWO',
        condition: (p, s, w, y, c, m, st, t, u) => c === true
    },
    {
        id: 'morse_code_day',
        name: 'Morse Code Day',
        description: 'Use the app on April 27th',
        icon: Calendar,
        level: 'Novice',
        color: 'text-blue-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('morse_code_day')
    },
    {
        id: 'adventure_keyboard',
        name: 'Radio Tower Restored',
        description: 'Complete the adventure using keyboard',
        icon: Trophy,
        level: 'Novice',
        color: 'text-green-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('adventure_keyboard')
    },
    {
        id: 'adventure_morse',
        name: 'Telegraph Operator',
        description: 'Complete the adventure using only Morse code',
        icon: Radio,
        level: 'General',
        color: 'text-amber-600',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('adventure_morse')
    },
    {
        id: 'pileup_buster',
        name: 'Pileup Buster',
        description: 'Isolate and copy 10 callsigns in Pileup Mode',
        icon: Radio,
        level: 'Extra',
        color: 'text-purple-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('pileup_buster')
    },
    {
        id: 'contest_king',
        name: 'Contest King',
        description: 'Complete 5 consecutive exchanges in Contest Mode without errors',
        icon: Trophy,
        level: 'Extra',
        color: 'text-yellow-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('contest_king')
    },
    {
        id: 'head_copy',
        name: 'Head Copy',
        description: 'Complete a session with Text Visibility turned off',
        icon: Ear,
        level: 'General',
        color: 'text-blue-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('head_copy')
    },
    {
        id: 'the_bug',
        name: 'The Bug',
        description: 'Send 100 characters using Bug input mode',
        icon: Zap,
        level: 'General',
        color: 'text-orange-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('the_bug')
    },
    /* Commented out Microphone achievements - feature pending
    {
        id: 'voice_of_morse',
        name: 'Voice of Morse',
        description: 'Decode 50 characters using Microphone input',
        icon: Mic,
        level: 'Novice',
        color: 'text-green-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('voice_of_morse') || m === true
    },
    {
        id: 'cheese_grater',
        name: 'Cheese Grater',
        description: 'First successful mic input',
        icon: Mic,
        level: 'Novice',
        color: 'text-orange-400',
        condition: (p, s, w, y, c, m, st, t, u) => m === true
    },
    */
    {
        id: 'zork_explorer',
        name: 'Zork Explorer',
        description: 'Enter the White House in Zork',
        icon: Globe,
        level: 'General',
        color: 'text-indigo-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('zork_explorer')
    },
    {
        id: 'blind_adventure',
        name: 'Blind Adventure',
        description: 'Complete an adventure chapter in Blind Mode',
        icon: EyeOff,
        level: 'Extra',
        color: 'text-slate-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('blind_adventure')
    },
    {
        id: 'weekly_warrior',
        name: 'Weekly Warrior',
        description: 'Complete a Weekly Challenge',
        icon: Calendar,
        level: 'Novice',
        color: 'text-red-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('weekly_warrior')
    },
    {
        id: 'streak_starter',
        name: 'Streak Starter',
        description: 'Achieve a 3-day practice streak',
        icon: Flame,
        level: 'Novice',
        color: 'text-blue-400',
        condition: (p, s, w, y, c, m, st, t, u) => st >= 3
    },
    {
        id: 'streak_master',
        name: 'Streak Master',
        description: 'Achieve a 7-day practice streak',
        icon: Flame,
        level: 'General',
        color: 'text-orange-600',
        condition: (p, s, w, y, c, m, st, t, u) => st >= 7
    },
    {
        id: 'streak_legend',
        name: 'Streak Legend',
        description: 'Achieve a 30-day practice streak',
        icon: Flame,
        level: 'Extra',
        color: 'text-purple-500',
        condition: (p, s, w, y, c, m, st, t, u) => st >= 30
    },
    {
        id: 'unstoppable',
        name: 'Unstoppable',
        description: 'Achieve a 100-day practice streak',
        icon: Trophy,
        level: 'Extra',
        color: 'text-purple-600',
        condition: (p, s, w, y, c, m, st, t, u) => st >= 100
    },
    // Koch Progression
    {
        id: 'koch_5',
        name: 'CW Novice',
        description: 'Unlock 5 characters',
        icon: Star,
        level: 'Novice',
        color: 'text-blue-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('koch_5') || p.level >= 5
    },
    {
        id: 'koch_10',
        name: 'CW Apprentice',
        description: 'Unlock 10 characters',
        icon: Medal,
        level: 'Novice',
        color: 'text-green-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('koch_10') || p.level >= 10
    },
    {
        id: 'koch_20',
        name: 'CW Master',
        description: 'Unlock 20 characters',
        icon: Trophy,
        level: 'General',
        color: 'text-amber-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('koch_20') || p.level >= 20
    },
    {
        id: 'koch_40',
        name: 'CW Legend',
        description: 'Unlock all characters',
        icon: Award,
        level: 'Extra',
        color: 'text-purple-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('koch_40') || p.level >= 40
    },
    // Score-based
    {
        id: 'score_1000',
        name: 'High Scorer',
        description: 'Reach 1000 points',
        icon: Zap,
        level: 'Novice',
        color: 'text-yellow-400',
        condition: (p, s, w, y, c, m, st, t, u) => s >= 1000
    },
    // Social
    {
        id: 'social_butterfly',
        name: 'Social Butterfly',
        description: 'Add your first friend',
        icon: Users,
        level: 'Novice',
        color: 'text-pink-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('social_butterfly')
    },
    {
        id: 'secret_agent',
        name: 'Secret Agent',
        description: 'Send 5 Morse code messages to friends',
        icon: Send,
        level: 'General',
        color: 'text-indigo-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('secret_agent')
    },
    {
        id: 'signal_intercepted',
        name: 'Signal Intercepted',
        description: 'Decode 5 messages received from friends',
        icon: Mail,
        level: 'General',
        color: 'text-blue-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('signal_intercepted')
    },
    // Comprehension
    {
        id: 'meteorologist',
        name: 'Meteorologist',
        description: 'Successfully complete 5 Local Weather drills',
        icon: Sunrise,
        level: 'General',
        color: 'text-sky-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('meteorologist')
    },
    {
        id: 'news_anchor',
        name: 'News Anchor',
        description: 'Successfully complete 5 Daily News drills',
        icon: Globe,
        level: 'General',
        color: 'text-blue-600',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('news_anchor')
    },
    {
        id: 'storyteller',
        name: 'Storyteller',
        description: 'Complete 5 Story/Joke drills',
        icon: BookOpen,
        level: 'Novice',
        color: 'text-purple-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('storyteller')
    },
    {
        id: 'mental_giant',
        name: 'Mental Giant',
        description: 'Get 100% accuracy on a Head Copy session',
        icon: Brain,
        level: 'Extra',
        color: 'text-purple-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('mental_giant')
    },
    // Health
    {
        id: 'comeback_kid',
        name: 'Comeback Kid',
        description: 'Recover to 100% health after falling below 20%',
        icon: Heart,
        level: 'General',
        color: 'text-red-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('comeback_kid')
    },
    {
        id: 'ironclad',
        name: 'Ironclad',
        description: 'Finish a Guided Learning session with full 100% health',
        icon: Shield,
        level: 'Extra',
        color: 'text-blue-300',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('ironclad')
    },
    // Knowledge
    {
        id: 'trivia_buff',
        name: 'Trivia Buff',
        description: 'Unlock 10 Trivia facts',
        icon: Lightbulb,
        level: 'Novice',
        color: 'text-yellow-400',
        condition: (p, s, w, y, c, m, st, t, u) => t >= 10
    },
    {
        id: 'trivia_explorer',
        name: 'Trivia Explorer',
        description: 'Unlock 25 trivia facts',
        icon: BookOpen,
        level: 'General',
        color: 'text-green-400',
        condition: (p, s, w, y, c, m, st, t, u) => t >= 25
    },
    {
        id: 'trivia_scholar',
        name: 'Trivia Scholar',
        description: 'Unlock 50 trivia facts',
        icon: BookOpen,
        level: 'General',
        color: 'text-amber-400',
        condition: (p, s, w, y, c, m, st, t, u) => t >= 50
    },
    {
        id: 'trivia_master',
        name: 'Trivia Master',
        description: 'Unlock 100 trivia facts',
        icon: BookOpen,
        level: 'Extra',
        color: 'text-purple-400',
        condition: (p, s, w, y, c, m, st, t, u) => t >= 100
    },
    {
        id: 'q_master',
        name: 'Q-Master',
        description: 'Correctly identify 50 Q-Codes',
        icon: Radio,
        level: 'General',
        color: 'text-teal-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('q_master')
    },
    {
        id: 'short_hand',
        name: 'Short Hand',
        description: 'Correctly identify 50 CW Abbreviations',
        icon: Zap,
        level: 'General',
        color: 'text-yellow-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('short_hand')
    },
    // Fun
    {
        id: 'the_73',
        name: 'Best Regards',
        description: 'Send "73" in any mode',
        icon: HeartHandshake,
        level: 'Novice',
        color: 'text-pink-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('the_73')
    },
    // Constellation Hunter
    {
        id: 'first_light',
        name: 'First Light',
        description: 'Complete your first constellation',
        icon: Star,
        level: 'Novice',
        color: 'text-blue-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('first_light')
    },
    {
        id: 'constellation_cartographer',
        name: 'Constellation Cartographer',
        description: 'Complete all 15 constellations in Standard mode',
        icon: Globe,
        level: 'General',
        color: 'text-cyan-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('constellation_cartographer')
    },
    {
        id: 'master_navigator',
        name: 'Master Navigator',
        description: 'Unlock all 10 Constellation Hunter modes',
        icon: Award,
        level: 'Extra',
        color: 'text-purple-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.constellationHunterModesUnlocked === true
    },
    {
        id: 'stargazers_precision',
        name: 'Stargazer\'s Precision',
        description: 'Complete any constellation with zero errors',
        icon: Target,
        level: 'General',
        color: 'text-green-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('stargazers_precision')
    },
    {
        id: 'celestial_speed_record',
        name: 'Celestial Speed Record',
        description: 'Complete any constellation in under 2 minutes',
        icon: Zap,
        level: 'Extra',
        color: 'text-yellow-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('celestial_speed_record')
    },
    {
        id: 'ensign_first_watch',
        name: "Ensign's First Watch",
        description: 'Reach a score of 40 in Signal Lamp',
        icon: Anchor,
        level: 'Novice',
        color: 'text-blue-300',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('ensign_first_watch')
    },
    {
        id: 'admiral_of_the_fleet',
        name: 'Admiral of the Fleet',
        description: 'Reach a score of 200 in Signal Lamp',
        icon: Trophy,
        level: 'Extra',
        color: 'text-yellow-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('admiral_of_the_fleet')
    },
    {
        id: 'master_of_the_mist',
        name: 'Master of the Mist',
        description: 'Correctly translate 10 signals in Storm Warning mode',
        icon: Wind,
        level: 'General',
        color: 'text-slate-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('master_of_the_mist')
    },
    {
        id: 'steel_nerves',
        name: 'Steel Nerves',
        description: 'Reach score 100 in Signal Lamp without losing a life',
        icon: Shield,
        level: 'Extra',
        color: 'text-cyan-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('steel_nerves')
    },
    {
        id: 'unsinkable',
        name: 'Unsinkable',
        description: 'Successfully translate a signal while down to your last heart',
        icon: Heart,
        level: 'General',
        color: 'text-red-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('unsinkable')
    },
    {
        id: 'eagle_eye_lamp',
        name: 'Eagle Eye',
        description: 'Translate 20 signals in a row without a single typo',
        icon: Target,
        level: 'Extra',
        color: 'text-green-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('eagle_eye_lamp')
    },
    {
        id: 'ghost_in_static',
        name: 'Ghost in the Static',
        description: 'Copy a long signal (7+ chars) in Storm Warning mode',
        icon: Ghost,
        level: 'General',
        color: 'text-purple-300',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('ghost_in_static')
    },
    {
        id: 'independent_operator',
        name: 'Independent Operator',
        description: 'Reach score 100 without using the Auto-Repeat mechanism',
        icon: Zap,
        level: 'Extra',
        color: 'text-amber-500',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('independent_operator')
    },
    {
        id: 'distress_call_relayed',
        name: 'Distress Call Relayed',
        description: 'Correctly copy a distress signal (SOS, MAYDAY, or CQD)',
        icon: Radio,
        level: 'General',
        color: 'text-red-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('distress_call_relayed')
    },
    {
        id: 'grue_food',
        name: 'Grue Food',
        description: 'Get eaten by a Grue in Zork',
        icon: Ghost,
        level: 'General',
        color: 'text-purple-400',
        secret: true,
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('grue_food')
    },
    // ProQSO Operator Achievements
    {
        id: 'pro_qso_ragchewer',
        name: "Old Timer's Club",
        description: 'Successfully complete a conversation with a Ragchewer',
        icon: UserPlus,
        level: 'General',
        color: 'text-success',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('pro_qso_ragchewer')
    },
    {
        id: 'pro_qso_contester',
        name: 'Sweepstakes Champ',
        description: 'Complete a Contester contact at 35+ WPM',
        icon: Zap,
        level: 'Extra',
        color: 'text-warning',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('pro_qso_contester')
    },
    {
        id: 'pro_qso_newbie_helper',
        name: 'Elmer',
        description: 'Patiently help a Newbie through their contact',
        icon: HeartHandshake,
        level: 'Novice',
        color: 'text-info',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('pro_qso_newbie_helper')
    },
    {
        id: 'pro_qso_elite',
        name: 'Shack Veteran',
        description: 'Complete a Pro contact by ear with all assists disabled',
        icon: Award,
        level: 'Extra',
        color: 'text-primary',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('pro_qso_elite')
    },
    {
        id: 'pro_qso_persona_master',
        name: 'Omni-Channel',
        description: 'Complete a QSO with all 4 operator types',
        icon: Trophy,
        level: 'Extra',
        color: 'text-purple-400',
        condition: (p, s, w, y, c, m, st, t, u) => u.achievements?.includes('pro_qso_persona_master')
    }
];
